// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import Vue from 'vue'
// import Element from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
// Vue.use(Element);
import App from './App'
import router from './router'
import axios from 'axios';
axios.defaults.baseURL = '/api'
// import BaiduMap from 'vue-baidu-map';
import './assets/base.css'
// import "swiper/swiper.min.css"

import * as custom from '@/utils/filters'
// ȫ��ע��
//引入echarts
// import * as echarts from 'echarts';
// Vue.prototype.$echarts = echarts;
import { VueJsonp } from 'vue-jsonp'
Vue.use(VueJsonp)

Object.keys(custom).forEach(key => { Vue.filter(key, custom[key])})

Vue.prototype.$axios = axios;

Vue.config.productionTip = false

// Vue.use(BaiduMap, {
//   /* Visit http://lbsyun.baidu.com/apiconsole/key for details about app key. */
//   ak: 'LlFdWUozzADQC6n2El3gNGtwM4MbhRpb'
// })


Vue.directive('preventReClick', {
	inserted(el, binding) {
   	  el.addEventListener('click', () => {
     	if (!el.disabled) {
      	 el.disabled = true
      	 setTimeout(() => {
        	 el.disabled = false
       	}, binding.value || 2000)
     	}
   	})
	 }
});


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  beforeCreate(){
    Vue.prototype.$bus = this;
  },
})



// WEBPACK FOOTER //
// ./src/main.js